import { Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';

const Loading: React.FC = () => (
  <div className="flex flex-col gap-4" data-testid="sso-loading">
    <Skeleton className="h-8 w-64" />
    <Skeleton className="h-40 w-full" />
    <Skeleton className="h-40 w-full" />
  </div>
);

export default observer(Loading);
